import { Form, Formik } from 'formik'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { SheetContext } from '../../../lib/Context'
import Text from '../../Elements/Text'
import Button from '../../Formik/Button'
import Checkbox from '../../Formik/Checkbox'
import Input from '../../Formik/Input'
import Select from '../../Formik/Select'
import { AccountingType } from '../lib/Enums/AccountingType'
import { useUpdateSheet } from '../lib/Hooks/Sheet'

const Configuration = () => {
  const { t } = useTranslation(['accounting'])
  const { sheet: accounting } = useContext(SheetContext)
  const { mutate: saveSheet, isPending: isSaving } = useUpdateSheet()

  const submit = async (
    type: AccountingType,
    budget: number,
    dedicatedAccount: boolean,
    startingBalance: number,
  ) => {
    const newSheet = structuredClone(accounting)
    newSheet.type = type
    newSheet.budget = budget
    newSheet.dedicated_account = dedicatedAccount
    newSheet.starting_balance = startingBalance

    saveSheet(newSheet)
  }

  const getBudgetType = () => {
    switch (accounting.type) {
      case AccountingType.WEEK:
        return t('accounting:configuration.budgetType.week')
      case AccountingType.MONTH:
        return t('accounting:configuration.budgetType.month')
      case AccountingType.YEAR:
        return t('accounting:configuration.budgetType.year')
      default:
        return ''
    }
  }

  return (
    <div className='my-5'>
      <Text className='mb-5'>
        {t('accounting:configuration.description')}
      </Text>
      <Formik
        initialValues={{
          type: accounting.type || AccountingType.REGULAR,
          budget: accounting.budget || '',
          dedicatedAccount: accounting.dedicated_account,
          startingBalance: accounting.starting_balance,
        }}
        onSubmit={({ type, budget, dedicatedAccount, startingBalance }) =>
          submit(
            type,
            budget === '' ? null : budget,
            dedicatedAccount,
            startingBalance,
          )
        }
      >
        {({ values: { dedicatedAccount } }) => (
          <Form>
            <p className='mb-2'>{t('accounting:configuration.type')}</p>
            <Select name='type' className='mb-3'>
              <option value={AccountingType.REGULAR}>
                {t('accounting:configuration.options.accounting')}
              </option>
              <option value={AccountingType.YEAR}>
                {t('accounting:configuration.options.year')}
              </option>
              <option value={AccountingType.MONTH}>
                {t('accounting:configuration.options.month')}
              </option>
              <option value={AccountingType.WEEK}>
                {t('accounting:configuration.options.week')}
              </option>
            </Select>
            <p className='mb-2'>{t('accounting:configuration.budget')}</p>
            <Input
              name='budget'
              placeholder={t('accounting:configuration.budgetPlaceholder', {
                budgetType: getBudgetType(),
              })}
              className='mb-5'
            />
            <Checkbox name='dedicatedAccount' className='mb-5'>
              {t('accounting:configuration.dedicatedAccount')}
            </Checkbox>
            {dedicatedAccount && (
              <div className='mb-5'>
                <p className='mb-2'>{t('accounting:configuration.balance')}</p>
                <Input
                  type='number'
                  name='startingBalance'
                  placeholder={t(
                    'accounting:configuration.balancePlaceholder',
                  )}
                />
              </div>
            )}
            <Button type='submit' className='w-full' loading={isSaving}>
              {t('accounting:configuration.save')}
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default Configuration
